import { APP_BRANDING_CONFIG_SERVICE, IAppBrandingConfigService } from '../app-branding-config';
import { combineLatest, from, Observable } from 'rxjs';
import { combinePadOption } from './pad-options.utils';
import { CONFIGURATION_SERVICE, IConfigurationService } from '../configuration';
import { finalize, map, shareReplay, takeUntil } from 'rxjs/operators';
import { FULL_STATE } from '../../interfaces/functions.interface';
import { inject, injectable } from 'inversify';
import { IPadOptions, IPadOptionsService } from './pad-options.interface';
import { ISessionLifecycle, SESSION_LIFECYCLE_SERVICE } from '../session-lifecycle';
import {
    ITradingSettingsProviderService,
    TRADING_SETTINGS_PROVIDER_SERVICE,
} from '../trading-settings-provider';
import { pluckTyped } from '../../helpers';
import { TRADE_PAD_DEFAULT_SETTINGS } from '../../mocks/pad-config.data';

@injectable()
export class PadOptionsService implements IPadOptionsService {

    @inject(APP_BRANDING_CONFIG_SERVICE) private readonly appBrandingConfigSrv: IAppBrandingConfigService;
    @inject(TRADING_SETTINGS_PROVIDER_SERVICE) private readonly settingsProvider: ITradingSettingsProviderService;
    @inject(SESSION_LIFECYCLE_SERVICE) private readonly sessionLifeCycle: ISessionLifecycle;
    @inject(CONFIGURATION_SERVICE) private readonly configurationSrv: IConfigurationService;

    configObs = (): Observable<IPadOptions> =>
        this.config$ ?? (this.config$ =
            combineLatest([
                this.settingsProvider.stateObservable(FULL_STATE),
                from(this.appBrandingConfigSrv.get()).pipe(
                    pluckTyped('tradingPad'),
                    map(tradingPad => {
                        return {
                            ...TRADE_PAD_DEFAULT_SETTINGS,
                            ...tradingPad,
                        };
                    }),
                ),
                this.configurationSrv.asObservable(),
            ]).pipe(
                takeUntil(this.sessionLifeCycle.destroyObservable()),
                map(combinePadOption),
                finalize(() => delete this.config$),
                shareReplay(1),
            )
        );

    private config$: Observable<IPadOptions>;
}
